<template>
  <default-layout>
    <event-navbar title="Für dich" />
    <div class="container py-2">
      <recommendation-index :event-short-name="shortName" />
    </div>
  </default-layout>
</template>

<script>
import EventNavbar from '@/components/EventNavbar.vue'
import DefaultLayout from '@/components/DefaultLayout.vue'
import RecommendationIndex from '@/components/recommendation/recommendation-index.vue'

export default {
  name: 'RecommendationHubView',
  components: { EventNavbar, DefaultLayout, RecommendationIndex },
  computed: {
    shortName() {
      return this.$route.params.shortName
        || this.$storage.observed.currentEventShortName
        || ''
    },
  },
}
</script>
